const enabled = (value: string | undefined, fallback: boolean) =>
  value === undefined ? fallback : value === "true";

const stagingDefault =
  import.meta.env.MODE === "staging" ||
  import.meta.env.MODE === "test" ||
  import.meta.env.DEV;

/** Independent client rollback controls. Staging enables all four. */
export const FEATURE_FLAGS = {
  silenceGuard: enabled(
    import.meta.env.VITE_DICTA_FEATURE_SILENCE_GUARD,
    stagingDefault
  ),
  minuteView: enabled(import.meta.env.VITE_DICTA_FEATURE_MINUTE_VIEW, stagingDefault),
  quickStart: enabled(import.meta.env.VITE_DICTA_FEATURE_QUICK_START, stagingDefault)
} as const;
